export default class RequestAgentRead {
  constructor(context) {
    this.context = context;
  }

  run({ conversationId, customerId, agentId }) {
    const customerStores = this.context.stores.customers.storesFor(customerId);
    customerStores.agentRead.setLoading();
    this.context.gateways.agentRead.request({ conversationId, agentId });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation/request_agent_read.js